import BodyCellPlain from "./TableComponents/BodyCellPlain";
import TableEditRow from "./TableComponents/TableEditRow";

const TableRowCustom = ({ row, table }) => {
  const rowOrgId = row.id;
  const editableRowId = table.options.state.editRowIndex;
  return rowOrgId === editableRowId ? (
    <TableEditRow row={row} table={table} />
  ) : (
    <tr
      className="live-view-table-row"
      style={{ borderBottom: "1px solid silver" }}
    >
      {row.getLeftVisibleCells().map((cell) => {
        return <BodyCellPlain cell={cell} table={table} row={row} stickLeft />;
      })}
      {row.getCenterVisibleCells().map((cell) => {
        return <BodyCellPlain cell={cell} table={table} row={row} />;
      })}
      {row.getRightVisibleCells().map((cell) => {
        return <BodyCellPlain cell={cell} table={table} row={row} stickRight />;
      })}
    </tr>
  );
};
export default TableRowCustom;
